import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=e51d4144&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=e51d4144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51d4144",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarButton: require('/builds/mytia/mege-educacional/components/NavBarButton.vue').default})
